export const pointsConfig = {
  ranks: {
    rookie: {
      label: "Rookie",
      icon: "/rookieBadge.svg",
      disabledIcon: "/rookieBadgeDisabled.svg",
      frameIcon: "/rookieBadgeFrame.svg",
      code: "rookie",
      min: 1,
      max: 1000,
    },
    veteran: {
      label: "Veteran",
      icon: "/veteranBadge.svg",
      disabledIcon: "/veteranBadgeDisabled.svg",
      frameIcon: "/veteranBadgeFrame.svg",
      code: "veteran",
      min: 1001,
      max: 2000,
    },
    elite: {
      label: "Elite",
      icon: "/eliteBadge.svg",
      disabledIcon: "/eliteBadgeDisabled.svg",
      frameIcon: "/eliteBadgeFrame.svg",
      code: "elite",
      min: 2001,
      max: 3000,
    },
    pro: {
      label: "Pro",
      icon: "/proBadge.svg",
      disabledIcon: "/proBadgeDisabled.svg",
      frameIcon: "/proBadgeFrame.svg",
      code: "pro",
      min: 3001,
      max: 4000,
    },
    master: {
      label: "Master",
      icon: "/masterBadge.svg",
      disabledIcon: "/masterBadgeDisabled.svg",
      frameIcon: "/masterBadgeFrame.svg",
      code: "master",
      min: 4001,
      max: 6000,
    },
    grandMaster: {
      label: "Grand Master",
      icon: "/grandMasterBadge.svg",
      disabledIcon: "/grandMasterBadgeDisabled.svg",
      frameIcon: "/grandMasterBadgeFrame.svg",
      code: "grandMaster",
      min: 6001,
      max: 8000,
    },
    legendary: {
      label: "Legendary",
      icon: "/legendaryBadge.svg",
      disabledIcon: "/legendaryBadgeDisabled.svg",
      frameIcon: "/legendaryBadgeFrame.svg",
      code: "legendary",
      min: 8001,
      max: "above",
    },
  },
  tabs: {
    points: {
      label: "Points",
      code: "points",
    },
    leaderboard: {
      label: "Leaderboard",
      code: "leaderboard",
    },
    rewards: {
      label: "Rewards",
      code: "rewards",
    },
    badges: {
      label: "Badges",
      code: "badges",
    },
    referrals: {
      label: "Referrals",
      code: "referrals",
    },
    log: {
      label: "Log",
      code: "log",
    },
  },
  badges: {
    person: {
      code: "profile",
      active: "/badgePerson.svg",
      inactive: "/badgePersonBlack.svg",
    },
    rocket: {
      code: "rocket",
      active: "/badgeRocket.svg",
      inactive: "/badgeRocketBlack.svg",
    },
    star: {
      code: "star",
      active: "/badgeStar.svg",
      inactive: "/badgeStarBlack.svg",
    },
    flight: {
      code: "flight",
      active: "/badgePlane.svg",
      inactive: "/badgePlaneBlack.svg",
    },
    hotel: {
      code: "hotel",
      active: "/badgeHotel.svg",
      inactive: "/badgeHotelBlack.svg",
    },
    tour: {
      code: "tour",
      active: "/badgePackage.svg",
      inactive: "/badgePackageBlack.svg",
    },
    insurance: {
      code: "insurance",
      active: "/badgeInsurance.svg",
      inactive: "/badgeInsuranceBlack.svg",
    },
    shop: {
      code: "shop",
      active: "/badgeShop.svg",
      inactive: "/badgeShopBlack.svg",
    },
    package: {
      code: "package",
      active: "/badgeMultiProduct.svg",
      inactive: "/badgeMultiProductBlack.svg",
    },
    partner: {
      code: "partner",
      active: "/badgePartner.svg",
      inactive: "/badgePartnerBlack.svg",
    },
    marketplace: {
      code: "marketplace",
      active: "/badgeMarketplace.svg",
      inactive: "/badgeMarketplaceBlack.svg",
    },
    repeat: {
      code: "repeat",
      active: "/badgeRepeat.svg",
      inactive: "/badgeRepeatBlack.svg",
    },
  },
  missionCreation: {
    missionTypes: {
      bookingCount: {
        code: "BOOKING_COUNT",
        label: "Booking Count",
      },
      platformActions: {
        code: "PLATFORM_ACTIONS",
        label: "Platform Actions",
      },
      salesTarget: {
        code: "SALES_TARGET",
        label: "Sales Target",
      },
      kycCompletion: {
        code: "KYC_COMPLETION",
        label: "KYC Completion",
      },
      referralCount: {
        code: "REFERAL_COUNT",
        label: "Referral Count",
      },
      supplierLoyalty: {
        code: "SUPPLIER_LOYALTY",
        label: "Supplier Loyality",
      },
    },
    frequency: {
      oneTime: { label: "One Time", code: "ONE_TIME" },
      recurring: { label: "Reoccurring", code: "RECCURRING" },
    },
    coin: {
      gold: { label: "Gold", code: "gold", icon: "/goldCoin.png" },
      silver: { label: "Silver", code: "silver", icon: "/silverCoin.png" },
      bronze: { label: "Bronze", code: "bronze", icon: "/bronzeCoin.png" },
    },
  },
  rewardCreation: {
    rewardTypes: {
      wallet: {
        code: "WALLET",
        label: "Wallet",
      },
      subscription: {
        code: "SUBSCRIPTION",
        label: "Subscription",
      },
      airtime: {
        code: "AIR_TIME",
        label: "Airtime",
      },
      booking: {
        code: "BOOKING",
        label: "Booking",
      },
    },
    bookingDiscountTypes: {
      fixed: { code: "FIXED", label: "Fixed" },
      percentage: { code: "PERCENTAGE", label: "Percentage" },
    },
  },
  timeFrameOptions: [
    "1 day",
    "7 Days",
    "14 days",
    "30 days",
    "60 days",
    "Lifetime",
  ],
  supplierOptions: ["Amadeus", "Sabre", "Travelport"],
};
